export default "__VITE_ASSET__59583456__"